import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '@/root-store';

import { ICity } from '../model/city';
import { Pressure } from '../model/pressure';
import { namespace as commonNamespace } from '../namespace';

const getPressure = (state: RootState) => state[commonNamespace].pressure;

const initialState: { cities: ICity[]; pressure: Pressure | null } = {
  cities: [],
  pressure: null,
};

const commonSlice = createSlice({
  name: commonNamespace,
  initialState,
  reducers: {
    setCities: (state, action: PayloadAction<ICity[]>) => {
      state.cities = action.payload;
    },
    setPressure: (state, action: PayloadAction<Pressure | null>) => {
      state.pressure = action.payload;
    },
  },
});

export const { setCities, setPressure } = commonSlice.actions;

export { commonSlice, commonNamespace, getPressure };
